import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { del } from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const useDelete = () => {
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleteError, setIsDeleteError] = useState("");
  const [deleteResult, setDeleteResult] = useState(null);

  const executeDelete = async (apiUrl) => {
    setIsDeleting(true);
    try {
      const response = await del(apiUrl);
      setDeleteResult(response.data);
      isDeleteError && setIsDeleteError("")
    } catch (error) {
      if (error.response && error.response.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setIsDeleteError(error.response?.data || error.response?.data?.message || error.message);
      }
    } finally {
      setIsDeleting(false);
    }
  };
  return {
    executeDelete,
    isDeleting,
    isDeleteError,
    deleteResult,
    setIsDeleteError,
    setDeleteResult,
  };
};

export default useDelete;
